// Centralised category list — add a new category here once and it shows everywhere.
export const CATEGORIES = [
  { value: "chopping_board", label: "Chopping Boards", singular: "Chopping Board" },
  { value: "resin_platter", label: "Resin Platters", singular: "Resin Platter" },
  { value: "furniture", label: "Furniture", singular: "Furniture" },
  { value: "miscellaneous", label: "Miscellaneous", singular: "Miscellaneous" },
];

export const categoryLabel = (value, fallback = "Piece") => {
  const c = CATEGORIES.find((x) => x.value === value);
  return c?.singular || fallback;
};

export const categoryPlural = (value) => {
  const c = CATEGORIES.find((x) => x.value === value);
  return c?.label || value;
};
